import React from 'react';
import {compose} from 'redux';
import {connect} from "react-redux";
import AddressLink from "../AddressLink";
import DateDisplay from "../Boilerplate/DateDisplay";
import {Button, Card, Checkbox, Col, Divider, Row} from "antd";
import RfiSummary from "./Rfis/RfiSummary";
import SubmittalSummary from "./Submittals/SubmittalSummary";
import TaskSummary from "./Tasks/TaskSummary";
import PunchListSummary from "./PunchList/PunchListSummary";
import {withRouter} from "react-router";
import UserSmall from "../Boilerplate/UserSmall";
import ChatWall from "../Boilerplate/ChatWall";
import {CodeTag} from "../Boilerplate/CodeTag";
import {QuickInviteButton} from "../Boilerplate/QuickInviteButton";
import {addProjects, quickInviteUserEmailSingle} from "../../actions/projects";
import {canUpdate} from "../Boilerplate/permissions";
import LinkButton from "../Boilerplate/LinkButton";
import DocumentPhoto from "../Boilerplate/DocumentPhoto";

const HeadCard = (props) => (
  <Card
    title={<span className='list-title'>{props.project.resource.name} (#{props.project.resource.number})</span>}
    extra={
      <div className='bid-dashboard-controls'>
        <QuickInviteButton disabled={!canUpdate(props.project)} onInvite={props.onQuickInvite}/>
        <LinkButton
          to={(match) => `/projects/${match.params.id}/files/`}
          icon='folder-open'
          type='primary'
        >
          <span className='hidden inline visible-xl'>Files</span>
        </LinkButton>
        <Button icon='edit' onClick={props.onEdit} disabled={!canUpdate(props.project)}>
          <span className='hidden inline visible-xl'>Edit</span>
        </Button>
      </div>
    }
    className='bid-dashboard-info bid-dashboard-column-card'
  >
    <Row>
      <Divider className='margins-vertical-small' orientation='left'>Description</Divider>
      <p className='formatted-text text-column'>{props.project.resource.description}</p>
    </Row>
  </Card>
);

const _GraphCard = ({ history, match, style }) => (
  <Card title={<span>Status</span>} style={style}>
    <Row gutter={8}>
      <Col span={12}>
        <a onClick={() => history.push(`/projects/${match.params.id}/rfis/`)}>
          <h2 style={{ width: '100%', textAlign: 'center' }}>RFIs</h2>
          <RfiSummary/>
        </a>
      </Col>
      <Col span={12}>
        <a onClick={() => history.push(`/projects/${match.params.id}/submittals/`)}>
          <h2 style={{ width: '100%', textAlign: 'center' }}>Submittals</h2>
          <SubmittalSummary/>
        </a>
      </Col>
    </Row>
    <Row gutter={8}>
      <Col span={12}>
        <a onClick={() => history.push(`/projects/${match.params.id}/tasks/`)}>
          <h2 style={{ width: '100%', textAlign: 'center' }}>Tasks</h2>
          <TaskSummary/>
        </a>
      </Col>
      <Col span={12}>
        <a onClick={() => history.push(`/projects/${match.params.id}/punch-list/`)}>
          <h2 style={{ width: '100%', textAlign: 'center' }}>Punch List Items</h2>
          <PunchListSummary/>
        </a>
      </Col>
    </Row>
  </Card>
);
const GraphCard = withRouter(_GraphCard);

class ProjectDashboard extends React.Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    const { project } = this.props;
    const rowWidth = 24;
    const keyWidth = 11;
    const valWidth = rowWidth - keyWidth;
    return <React.Fragment>
      <Row gutter={24} align='top'>
        <Col key='1' xs={24} lg={17}>
          <HeadCard {...this.props}/>
          <Row type='flex' gutter={24}>
            <Col xs={24} md={12} className='bid-dashboard-info'>
              <Card title='Project Details'
                    className='bid-dashboard-info bid-dashboard-column-card bid-dashboard-list-card'>
                <Row className='key-value'>
                  <Col span={keyWidth}>Site Address</Col>
                  <Col span={valWidth}>
                    <AddressLink style={{ fontSize: 16, fontWeight: 600 }} address={{
                      street: [project.resource.address, project.resource.address2].join('\n'),
                      city: project.resource.city,
                      state: project.resource.state,
                      zip: project.resource.zip,
                    }}/>
                  </Col>
                </Row>
                <br/>
                <br/>
                <Row className='key-value'>
                  <Col span={keyWidth}>Status</Col>
                  <Col span={valWidth}><CodeTag table='projectstatus' code={project.resource.status}/></Col>
                </Row>
                <Row className='key-value'>
                  <Col span={keyWidth}>Date Opened</Col>
                  <Col span={valWidth}><DateDisplay date={project.resource.dateopened}/></Col>
                </Row>
                <Row className='key-value'>
                  <Col span={keyWidth}>Estimated Cost</Col>
                  <Col
                    span={valWidth}>$ {project.resource.contractsize && project.resource.contractsize.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}</Col>
                </Row>
                {project.resource.estimatedcost &&
                <Row className='key-value'>
                  <Col span={keyWidth}>Estimated Cost (Free Text)</Col>
                  <Col span={valWidth}>{project.resource.estimatedcost}</Col>
                </Row>
                }
                <Row className='key-value'>
                  <Col span={keyWidth}>Entered By</Col>
                  <Col span={valWidth}><UserSmall id={project.resource.owneruserid}/></Col>
                </Row>
              </Card>
            </Col>
            <Col xs={24} md={12} className='bid-dashboard-info'>
              <Card title='Project Information'
                    className='bid-dashboard-info bid-dashboard-column-card bid-dashboard-list-card'>
                <Row className='key-value'>
                  <Col span={keyWidth}>Customer Name</Col>
                  <Col span={valWidth} className='formatted-text'>{project.resource.customername}</Col>
                </Row>
                <Row className='key-value'>
                  <Col span={keyWidth}>Architect</Col>
                  <Col span={valWidth} className='formatted-text'>{project.resource.architectname}</Col>
                </Row>
                <Row className='key-value'>
                  <Col span={keyWidth}>Engineer</Col>
                  <Col span={valWidth} className='formatted-text'>{project.resource.engineername}</Col>
                </Row>
                <Row className='key-value'>
                  <Col span={keyWidth}>Site Owner</Col>
                  <Col span={valWidth} className='formatted-text'>{project.resource.siteownername}</Col>
                </Row>
                <Divider>CSI Codes</Divider>
                <Row>
                  <Col span={rowWidth}>
                    {project.resource.csicodes && project.resource.csicodes.map(code =>
                      <CodeTag table='csi' key={code} code={code}/>)}
                  </Col>
                </Row>
                <Divider>Industries</Divider>
                <Row>
                  <Col span={rowWidth}>
                    {project.resource.industries && project.resource.industries.map(code =>
                      <CodeTag table='industry' key={code} code={code}/>)}
                  </Col>
                </Row>
                <Divider>Sectors</Divider>
                <Row>
                  <Col span={rowWidth}>
                    {project.resource.sectors && project.resource.sectors.map(code =>
                      <CodeTag table='sector' key={code} code={code}/>)}
                  </Col>
                </Row>
                <Divider>Set Asides</Divider>
                <Row>
                  <Col span={rowWidth}>
                    {project.resource.setasides && project.resource.setasides.map(code =>
                      <CodeTag table='setaside' key={code} code={code}/>)}
                  </Col>
                </Row>
                <Divider/>
                <Row className='bid-dashboard-boolean-flags'>
                  <Col span={8}><Checkbox checked={project.resource.newconstruction}>New Construction</Checkbox></Col>
                  <Col span={8}><Checkbox checked={project.resource.unionized}>Union</Checkbox></Col>
                  <Col span={8}><Checkbox checked={project.resource.certifiedpayroll}>Certified Payroll</Checkbox></Col>
                </Row>
                <Row>
                  <Col span={8}><Checkbox checked={project.resource.prevailingwage}>Prevailing Wage</Checkbox></Col>
                  <Col span={8}><Checkbox checked={project.resource.ccipinsurance}>CCIP Insurance</Checkbox></Col>
                </Row>
              </Card>
            </Col>
          </Row>
        </Col>
        <Col key='2' xs={24} lg={7} className='bid-dashboard-info'>
          <Row>
            <Col className='bid-dashboard-info'>
              <DocumentPhoto project={project} id={project.resource.id}/>
            </Col>
            <Col className='bid-dashboard-info'>
              <ChatWall projectId={project.resource.id}/>
            </Col>
          </Row>
        </Col>
      </Row>
      <Row gutter={24} style={{ marginBottom: 24 }}>
        <Col key='8' xs={24} className='bid-dashboard-info'>
          <GraphCard project={project}/>
        </Col>
      </Row>
    </React.Fragment>;
  }
}

export default compose(
  connect(
    (state, ownProps) => {
      let project = state.view.data[ownProps.match.params.id];
      project = {
        ...project,
        resource: {
          ...project.resource,
          company: state.companies.data[(project.resource || {}).ownercompanyid]
        }
      };

      return {
        project,
        profile: state.profile,
      };
    },
    (dispatch, props) => ({
      onAdd: (projects) => dispatch(addProjects(projects)),
      onEdit: () => props.history.push('/projects/' + props.match.params.id + '/edit'),
      onQuickInvite: (email) => dispatch(quickInviteUserEmailSingle(props.match.params.id, email)),
    })),
)(ProjectDashboard);



// WEBPACK FOOTER //
// ./src/components/Projects/ProjectDashboard.js